<div class="py-4 container-fluid compensation-summary-dashboard-page">
  <div class="compensation-summary-dashboard-heading">
    <div>
      <h4 class="mb-1 compensation-summary-dashboard-title">
        Dashboard Summary
      </h4>
    </div>

    <div class="compensation-summary-dashboard-toolbar" [formGroup]="form">
      <div class="compensation-summary-dashboard-filter">
        <app-select
          label="เทอมการศึกษา"
          formControlName="academicTerm"
          [options]="academicTermOptions"
          [searchable]="false"
          [clearable]="false"
          inputClass="compensation-summary-dashboard-select"
          classes="mb-0"
        ></app-select>
      </div>

      <div class="compensation-summary-dashboard-filter">
        <app-select
          label="ปีการศึกษา"
          formControlName="year"
          [options]="yearOptions"
          [searchable]="false"
          [clearable]="false"
          inputClass="compensation-summary-dashboard-select"
          classes="mb-0"
        ></app-select>
      </div>
    </div>
  </div>

  <div class="compensation-summary-dashboard-state" *ngIf="isLoading()">
    กำลังโหลด Dashboard Summary ค่าสอนชดเชย...
  </div>

  <div
    class="compensation-summary-dashboard-state compensation-summary-dashboard-state-error"
    *ngIf="!isLoading() && hasLoadError()"
  >
    ไม่สามารถโหลดข้อมูล Summary ค่าสอนชดเชยได้ กรุณาลองใหม่อีกครั้ง
  </div>

  <section class="compensation-summary-dashboard-card compensation-summary-dashboard-user-summary" aria-label="current user summary">
    <div class="compensation-summary-dashboard-user-profile">
      <span class="compensation-summary-dashboard-avatar" aria-hidden="true">
        <i class="bi bi-person-fill"></i>
      </span>

      <div>
        <h5>{{ currentUserName }}</h5>
        <p>{{ currentUserEmail }}</p>
        <p>{{ currentUserDepartment }}</p>
      </div>
    </div>

    <div class="compensation-summary-dashboard-term-summary">
      <strong>ภาคการศึกษา {{ academicTermLabel }}</strong>
      <span>ปีการศึกษา {{ academicYearLabel }}</span>
    </div>
  </section>

  <section class="compensation-summary-dashboard-kpis" aria-label="request metrics">
    <div
      class="compensation-summary-dashboard-card compensation-summary-dashboard-kpi"
      *ngFor="let metric of requestMetrics"
      [ngClass]="getMetricClass(metric)"
    >
      <span class="compensation-summary-dashboard-kpi-icon" aria-hidden="true">
        <i class="bi" [ngClass]="metric.icon"></i>
      </span>

      <span class="compensation-summary-dashboard-kpi-copy">
        <span>{{ metric.label }}</span>
        <strong>
          {{ metric.value }}
          <small *ngIf="metric.unit">{{ metric.unit }}</small>
        </strong>
      </span>
    </div>
  </section>

  <section class="compensation-summary-dashboard-analysis" aria-label="compensation analysis">
    <div class="compensation-summary-dashboard-card compensation-summary-dashboard-chart-card">
      <div class="compensation-summary-dashboard-section-header">
        <h6>สถานะการรับรองคำขอ</h6>
      </div>

      <div class="compensation-summary-dashboard-request-chart">
        <apx-chart
          [series]="requestStatusChartOptions.series"
          [chart]="requestStatusChartOptions.chart"
          [labels]="requestStatusChartOptions.labels"
          [colors]="requestStatusChartOptions.colors"
          [dataLabels]="requestStatusChartOptions.dataLabels"
          [legend]="requestStatusChartOptions.legend"
          [plotOptions]="requestStatusChartOptions.plotOptions"
          [responsive]="requestStatusChartOptions.responsive"
          [stroke]="requestStatusChartOptions.stroke"
          [tooltip]="requestStatusChartOptions.tooltip"
        ></apx-chart>

        <div class="compensation-summary-dashboard-chart-legend">
          <div>
            <span class="compensation-summary-dashboard-dot compensation-summary-dashboard-dot-success"></span>
            <span>รับรองแล้ว</span>
            <strong>{{ summary().approved_request_count }} รายการ ({{ requestApprovalRate }})</strong>
          </div>
          <div>
            <span class="compensation-summary-dashboard-dot compensation-summary-dashboard-dot-warning"></span>
            <span>ยังไม่รับรอง</span>
            <strong>{{ summary().pending_request_count }} รายการ</strong>
          </div>
        </div>
      </div>

      <p class="compensation-summary-dashboard-chart-note">{{ lastUpdatedLabel }}</p>
    </div>

    <div class="compensation-summary-dashboard-card compensation-summary-dashboard-chart-card">
      <div class="compensation-summary-dashboard-section-header compensation-summary-dashboard-section-header-inline">
        <h6>
          ภาพรวมภาระงานสอน (ชั่วโมง)
          <i class="bi bi-info-circle" aria-hidden="true"></i>
        </h6>
        <span>หน่วย: ชั่วโมง</span>
      </div>

      <div class="compensation-summary-dashboard-workload-chart">
        <apx-chart
          [annotations]="workloadChartOptions.annotations"
          [series]="workloadChartOptions.series"
          [chart]="workloadChartOptions.chart"
          [colors]="workloadChartOptions.colors"
          [dataLabels]="workloadChartOptions.dataLabels"
          [fill]="workloadChartOptions.fill"
          [grid]="workloadChartOptions.grid"
          [legend]="workloadChartOptions.legend"
          [plotOptions]="workloadChartOptions.plotOptions"
          [stroke]="workloadChartOptions.stroke"
          [tooltip]="workloadChartOptions.tooltip"
          [xaxis]="workloadChartOptions.xaxis"
          [yaxis]="workloadChartOptions.yaxis"
        ></apx-chart>

        <div class="compensation-summary-dashboard-workload-values" aria-hidden="true">
          <span>{{ formatHours(summary().minimum_teaching_workload) }}</span>
          <span>{{ formatHours(summary().teaching_workload) }}</span>
          <span>{{ formatHours(summary().makeup_teaching_workload) }}</span>
          <span>{{ formatHours(summary().total_teaching_workload) }}</span>
          <span>{{ formatHours(summary().excess_hours) }}</span>
        </div>
      </div>
    </div>
  </section>

  <section class="compensation-summary-dashboard-card compensation-summary-dashboard-calculation" aria-label="compensation calculation summary">
    <div class="compensation-summary-dashboard-section-header">
      <h6>สรุปคำนวณค่าสอนชดเชย</h6>
    </div>

    <div class="compensation-summary-dashboard-calculation-grid">
      <div class="compensation-summary-dashboard-rule-stack">
        <div class="compensation-summary-dashboard-rule-card">
          <div class="compensation-summary-dashboard-rule-title">
            <i class="bi bi-book" aria-hidden="true"></i>
            <strong>หลักสูตรภาคปกติ</strong>
          </div>

          <div class="compensation-summary-dashboard-rule-row" *ngFor="let rule of regularCurriculumRules">
            <span>{{ rule.label }}</span>
            <strong>{{ rule.value }}</strong>
          </div>
          <small>ชั่วโมงสอนขั้นต่ำต่อภาคการศึกษา</small>
        </div>

        <div class="compensation-summary-dashboard-rule-card">
          <div class="compensation-summary-dashboard-rule-title">
            <i class="bi bi-cash-coin" aria-hidden="true"></i>
            <strong>อัตราค่าสอนเกินภาระงาน</strong>
          </div>

          <div class="compensation-summary-dashboard-rule-row" *ngFor="let rule of compensationRateRules">
            <span>{{ rule.label }}</span>
            <strong>{{ rule.value }}</strong>
          </div>
          <small>ใช้สำหรับการคำนวณชั่วโมงเกินภาระงาน</small>
        </div>
      </div>

      <div class="compensation-summary-dashboard-calculation-panel">
        <div class="compensation-summary-dashboard-section-header compensation-summary-dashboard-section-header-inline">
          <h6>
            ผลการคำนวณค่าสอนชดเชย (ตัวอย่าง)
            <i class="bi bi-info-circle" aria-hidden="true"></i>
          </h6>
        </div>

        <div class="compensation-summary-dashboard-table-scroll">
          <table class="compensation-summary-dashboard-calculation-table">
            <thead>
              <tr>
                <th>รายการ</th>
                <th>ปริญญาตรี</th>
                <th>บัณฑิตศึกษา</th>
                <th>รวม</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let row of compensationCalculationRows"
                [class.compensation-summary-dashboard-row-emphasis]="row.emphasis"
                [class.compensation-summary-dashboard-row-warning]="row.warning"
              >
                <td>{{ row.label }}</td>
                <td>{{ row.undergraduate }}</td>
                <td>{{ row.graduate }}</td>
                <td>{{ row.total }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="compensation-summary-dashboard-contribution">
          <div class="compensation-summary-dashboard-contribution-heading">
            <strong>สัดส่วนชั่วโมงเบิกได้</strong>
            <span>ปริญญาตรี 67.5 ชม. (100%)</span>
            <span>บัณฑิตศึกษา 0 ชม. (0%)</span>
          </div>
          <div class="compensation-summary-dashboard-contribution-bar" aria-hidden="true">
            <span class="compensation-summary-dashboard-contribution-primary">100%</span>
            <span class="compensation-summary-dashboard-contribution-empty">0%</span>
          </div>
          <p>คำนวณตามเงื่อนไข: ลดครึ่งหนึ่งของชั่วโมงรวม และปัดเศษครึ่งเป็นหนึ่ง</p>
        </div>
      </div>
    </div>
  </section>

  <section class="compensation-summary-dashboard-card compensation-summary-dashboard-international" aria-label="international compensation formulas">
    <div class="compensation-summary-dashboard-section-header">
      <h6>หลักสูตรพิเศษ/อินเตอร์</h6>
    </div>

    <div class="compensation-summary-dashboard-formula-list">
      <div class="compensation-summary-dashboard-formula-card" *ngFor="let formula of internationalFormulaCards">
        <i class="bi" [ngClass]="formula.icon" aria-hidden="true"></i>
        <strong>{{ formula.title }}</strong>
        <span>{{ formula.formula }}</span>
      </div>

      <div class="compensation-summary-dashboard-formula-card compensation-summary-dashboard-formula-note">
        <i class="bi bi-info-circle" aria-hidden="true"></i>
        <strong>หมายเหตุ</strong>
        <span>ถ้าภาระงานปกติน้อยกว่า 18 ชม./สัปดาห์ ให้นำชั่วโมงอินเตอร์มารวมให้ครบเกณฑ์</span>
      </div>
    </div>
  </section>
</div>
